import { useEffect, useState } from "react";

export function TopBar({ onContact }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="top-bar"
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-500 ${
        scrolled
          ? "bg-[#F4F1EA] border-b border-[#3F4E4F]/15"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-[1100px] items-center justify-between px-6 py-5 sm:px-8">
        <a
          href="#top"
          data-testid="wordmark"
          className={`text-[0.72rem] font-semibold uppercase tracking-[0.28em] transition-colors duration-500 hover:text-[#A27B5B] ${
            scrolled ? "text-[#2C3639]" : "text-[#DCD7C9]"
          }`}
        >
          Raintree Holdings
        </a>
        <button
          type="button"
          onClick={onContact}
          data-testid="get-in-touch-link"
          className={`text-[0.72rem] font-semibold uppercase tracking-[0.28em] underline decoration-transparent decoration-1 underline-offset-[5px] transition-colors duration-500 hover:text-[#A27B5B] hover:decoration-[#A27B5B] ${
            scrolled ? "text-[#2C3639]" : "text-[#DCD7C9]"
          }`}
        >
          Get in touch
        </button>
      </nav>
    </header>
  );
}
